<div style="display: flex; flex-direction: row; flex: 1; flex-wrap: wrap; justify-content: center">
    <div style="width: 100%;">
        <div style="display: flex; flex-direction: column">
            <!-- Key Row -->
            <div style="display: flex; flex: 1; justify-content: center;flex-wrap: wrap;">
                <div class="key-text"><img src="./assets/images/star amber.png" alt="Primary Contact" style="height:15px;margin-bottom:5px;">= Primary Contact</div>
                <div class="key-text"># = Emergency Contact Sequence</div>
                <div class="key-text"><b style="color:red;">R </b>= Restricted</div>
            </div>
            <!-- Contacts Table -->
            <div>
                <mat-table style="width: 100%;" multiTemplateDataRows [dataSource]="angularMatData" class="mat-elevation-z0">

                    <!-- Contact Key Column -->
                    <ng-container matColumnDef="contactKey">
                        <mat-header-cell *matHeaderCellDef style="flex: .4; padding-left: 10px"></mat-header-cell>
                        <mat-cell *matCellDef="let contact" style="flex: .4; padding-left: 10px">
                            <!-- Primary Contact -->
                            <div *ngIf="contact.IsPrimary"><img src="./assets/images/star amber.png" alt="Primary Contact" style="height:15px;margin-bottom:5px;"></div>
                            <!-- Restricted Contact -->
                            <div *ngIf="contact.IsRestricted"><b style="color:red;margin-left: 3px;">R</b></div>
                        </mat-cell>
                    </ng-container>

                    <!-- Contact Sequence Column -->
                    <ng-container matColumnDef="contactSequence">
                        <mat-header-cell *matHeaderCellDef style="flex: .3"></mat-header-cell>
                        <mat-cell *matCellDef="let contact" style="flex: .3">
                            <span *ngIf="contact.EmergencySequenceNumber > 0 && contact.IsEmergency">{{contact.EmergencySequenceNumber}}</span>
                        </mat-cell>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef style="flex: 4"><span translate>Name</span></mat-header-cell>
                        <mat-cell *matCellDef="let contact" style="flex: 4" [ngClass]="{'restricted-contact' : contact.IsRestricted}">{{contact.Contact_Name}}</mat-cell>
                    </ng-container>

                    <!-- Relationship Column -->
                    <ng-container matColumnDef="relationship">
                        <mat-header-cell *matHeaderCellDef style="flex: 4"><span translate>Relationship</span></mat-header-cell>
                        <mat-cell *matCellDef="let contact" style="flex: 4" [ngClass]="{'restricted-contact' : contact.IsRestricted}">{{contact.Relationship}}</mat-cell>
                    </ng-container>

                    <!-- Cell Column -->
                    <ng-container matColumnDef="cell">
                        <mat-header-cell *matHeaderCellDef style="flex: 3"><span translate>Cell</span></mat-header-cell>
                        <mat-cell *matCellDef="let contact" style="flex: 3" [ngClass]="{'restricted-contact' : contact.IsRestricted}">{{contact.CellNumber | phoneNumber}}</mat-cell>
                    </ng-container>

                    <!-- More Column -->
                    <ng-container matColumnDef="more">
                        <mat-header-cell *matHeaderCellDef style="min-width:68px;max-width:68px;text-align:center;" class="print-ignore"></mat-header-cell>
                        <mat-cell *matCellDef="let AH" style="min-width:68px;max-width:68px;justify-content: center;" class="print-ignore">
                            <span aria-label="Expand row for more details">
                                <i [ngClass]="checkExpanded(AH) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" aria-hidden="true"></i>
                            </span>
                        </mat-cell>
                    </ng-container>

                    <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                    <ng-container matColumnDef="expandedDetail">
                        <!-- Detail row can have standard html or another Angular Material table -->
                        <mat-cell *matCellDef="let contactDetails" [attr.colspan]="displayedColumns.length" style="width:100%;margin-left: 45px;">
                            <div style="flex: 1; display: flex; flex-direction: column">
                                <div style="display: flex; flex: 1">
                                    <div style="display: flex; flex: 1; flex-direction: column">
                                        <div style="display: flex; flex: 1" *ngIf="contactDetails.IsRestricted" class="restricted-contact">RESTRICTED</div>
                                        <!-- Contact Info -->
                                        <div class="row-details" *ngIf="contactDetails.IsEmergency">
                                            <div class="row-detail-label" style="display: flex; flex: 1">Emergency</div>
                                            <div style="display: flex; flex: 1">{{contactDetails.EmergencyNumber | phoneNumber}}</div>
                                        </div>
                                        <div class="row-details">
                                            <div class="row-detail-label" style="display: flex; flex: 1">Home</div>
                                            <div style="display: flex; flex: 1">{{contactDetails.HomeNumber | phoneNumber}}</div>
                                        </div>
                                        <div class="row-details">
                                            <div class="row-detail-label" style="display: flex; flex: 1">Work</div>
                                            <div style="display: flex; flex: 1">{{contactDetails.WorkNumber | phoneNumber}}</div>
                                        </div>
                                        <div class="row-details">
                                            <div class="row-detail-label" style="display: flex; flex: 1">Employer</div>
                                            <div style="display: flex; flex: 1">{{contactDetails.Employer}}</div>
                                        </div>
                                        <div class="row-details">
                                            <div class="row-detail-label" style="display: flex; flex: 1; flex-direction: column; padding-top: 10px">
                                                <div class="row-detail-label" style="display: flex; flex: 1">Email</div>
                                                <span class="link" style="color:#3f51b5" (click)="sendEmail(contactDetails.Name, contactDetails.Email)">{{contactDetails.Email}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="display: flex; flex: 1; flex-direction: column">
                                        <!-- Contact Details -->
                                        <div class="row-details">
                                            <div class="row-detail-label" style="display: flex; flex: 1">Portal Access</div>
                                            <div style="display: flex; flex: 1">{{contactDetails.ParentPortalAccess ? 'Y' : 'N'}}</div>
                                        </div>
                                        <div class="row-details">
                                            <div class="row-detail-label" style="display: flex; flex: 1">Is Guardian</div>
                                            <div style="display: flex; flex: 1">{{contactDetails.IsGuardian ? 'Y' : 'N'}}</div>
                                        </div>
                                        <div class="row-details">
                                            <div class="row-detail-label" style="display: flex; flex: 1" [ngClass]="{'restricted-contact' : !contactDetails.CanPickUp}">Can Pick Up</div>
                                            <div style="display: flex; flex: 1" [ngClass]="{'restricted-contact' : !contactDetails.CanPickUp}">{{contactDetails.CanPickUp ? 'Y' : 'N'}}</div>
                                        </div>
                                        <div class="row-details">
                                            <div class="row-detail-label" style="display: flex; flex: 1">Lives With</div>
                                            <div style="display: flex; flex: 1">{{contactDetails.LivesWith ? 'Y' : 'N'}}</div>
                                        </div>
                                        <div class="row-details">
                                            <div class="row-detail-label" style="display: flex; flex: 1">Has Custody</div>
                                            <div style="display: flex; flex: 1">{{contactDetails.HasCustody ? 'Y' : 'N'}}</div>
                                        </div>
                                        <div class="row-details">
                                            <div class="row-detail-label" style="display: flex; flex: 1">Last Login</div>
                                            <div style="display: flex; flex: 1">{{contactDetails.LastLogin | date:'MM/dd/yy hh:m a'}}</div>
                                        </div>
                                    </div>
                                </div>
                                <div style="display: flex; flex: 1">
                                    <div style="display: flex; flex-direction: column; flex:1; margin-top: 10px">
                                        <div class="row-detail-label" style="display: flex; flex: 1">Primary Address</div>
                                        <div style="display: flex; flex: 1">{{contactDetails.PrimaryAddressLine1}}</div>
                                        <div style="display: flex; flex: 1">{{contactDetails.PrimaryAddressLine2}}</div>
                                    </div>
                                    <div style="display: flex; flex-direction: column; flex:1; margin-top: 10px">
                                        <div class="row-detail-label" style="display: flex; flex: 1">Mailing Address</div>
                                        <div style="display: flex; flex: 1">{{contactDetails.MailingAddressLine1}}</div>
                                        <div style="display: flex; flex: 1">{{contactDetails.MailingAddressLine2}}</div>
                                    </div>
                                </div>
                            </div>
                        </mat-cell>
                    </ng-container>

                    <mat-header-row  *matHeaderRowDef="displayedColumns; sticky: false"></mat-header-row>
                    <!-- Data rows -->
                    <mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                             id = "AHdataRow{{i}}"
                             tabindex="0"
                             [ngStyle]="{'border-bottom-width':checkExpanded(row) ? '0px' : '1px'}"
                             [ngClass]="{'pastEnrollment' : row.IsCurrent == false}"
                             style="padding:0;overflow: hidden;"
                             matRipple
                             (click)="toggleExpanded(row)"
                             (keydown)="rowKeyPress($event, row)">
                    </mat-row>
                    <!-- Detail row -->
                    <!-- 'overflow: hidden' is required for animation to render properly -->
                    <mat-row *matRowDef="let row; columns: ['expandedDetail']" [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'" style="overflow: hidden;">
                    </mat-row>
                </mat-table>
            </div>
        </div>
    </div>
</div>

